<template lang="pug">
    .b2b-page-approval-flows
      ods-module.box-card
        div(slot='header')
          ods-row.info(type='flex', align='middle')
            ods-col(:span='8')
              div {{ $t('centres.title_admin_approval_flows') }}
        ods-form(
          ref='centreApprovalAmountForm',
          label-width='14rem',
          label-position='top',
          size='small',
          status-icon)
          ods-row(type='flex')
            //- Tabla de niveles de aprobación (centre_approval_level)
            ods-table(
              :data='dataApprovalFlows',
              :default-sort="{ prop: 'level', order: 'ascending' }",
              style='width: 100%',
              @cell-mouse-enter='handleCellMouseEnterApprovalAmount',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='description',
                :label='$t("centres.approval_flow_data.description")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='amount',
                :label='$t("centres.approval_flow_data.amount")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='amountTo',
                :label='$t("centres.approval_flow_data.amountTo")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='purchaseOrder',
                :label='$t("centres.approval_flow_data.purchase_order")',
                :show-overflow-tooltip='true',
                sortable='')
                template(slot-scope='scope')
                  ods-switch(
                    :active-color='primaryColor',
                    inactive-color='#D5DCE0',
                    v-model='scope.row.purchaseOrder',
                    :disabled= 'true')
              ods-table-column(
                label='',
                width='80')
                template(slot-scope='scope')
                  ods-tooltip(:content='$t("msg_generics.detail")')
                    ods-button(
                      style=' padding-left: 0px; padding-right: 0px;'
                      type='neutral',
                      @click='handleGoApprovalFlow(scope.row)')
                      ods-icon(name='search', size='16')
                  ods-tooltip(:content='$t("buttons.btnDelete")')
                     ods-button(
                      style=' padding-left: 0px; padding-right: 0px;'
                      type='neutral',
                      @click='removeCentreApprovalAmount(scope.$index)')
                      ods-icon(name='close', size='16')
          ods-row(type='flex', justify='end')
            ods-tooltip(:content='$t("party_detail.buttons.add_contact_data")', placement='bottom')
              ods-button.button-collapse(
                icon='ods-icon-plus',
                size='small',
                circle,
                @click.native='handleNewFlow()')
                | {{ $t('party_detail.buttons.add_contact_data') }}

  </template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'
import router from '@/router/index'

export default {
  name: 'b2b-page-approval-flows',
  mixins: [Utils],
  data () {
    return {
      // DATOS
      dataApprovalFlows: [], // lista de flujos de aprobación
      currentRowApprovalAmount: {}, // fila seleccionada, para el borrado de un flujo de aprobación

      // Borrar
      centreApprovalAmountForm: {
      }
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      'primaryColor'
    ])
  },

  methods: {
    ...mapActions([
      'getPartyService',
      'getProjectPartyService',
      'getServiceDetail',
      'getCentreApprovalAmount', // Consulta de datos de centre_approval_amount
      'deleteCentreApprovalAmount' // Elimina un flujo de aprobación para el centro en 'centre_approval_amount'
    ]),

    /* Al pasar el ratón por encima de la celda de la tabla de flujos de aprobación */
    handleCellMouseEnterApprovalAmount (row, column, cell, event) {
      this.currentRowApprovalAmount = row
    },

    /* Ir a la administración del flujo de aprobación por niveles */
    async handleGoApprovalFlow (centre) {
      console.log('handleGoApprovalFlow: ', centre)
      let projectName
      let partyName

      if (this.$route.params.projectId) {
        const project = await this.getServiceDetail(this.$route.params.projectId)
        const party = await this.getPartyService({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId
        })
        projectName = project.name
        partyName = party.tradeName

        const response = await this.getProjectPartyService({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId
        })
        this.partySponsor = response.sponsor
        sessionStorage.setItem('partyName', party.corporateName)
        sessionStorage.setItem('projectName', project.name)
        sessionStorage.setItem('centreCode', centre.centreCode)
        sessionStorage.setItem('centreDescription', centre.centreDescription)

        const pageCentreName = 'page-approval-flow'
        router.push({
          name: pageCentreName,
          params: {
            centreApprovalAmountId: centre.id,
            centreId: centre.centreId,
            centreCode: centre.centreCode,
            projectName: projectName,
            partyName: partyName
          }
        })
      }
    },

    /* Ir a la administración del flujo de aprobación por niveles */
    async handleNewFlow () {
      let projectName
      let partyName

      if (this.$route.params.projectId) {
        const project = await this.getServiceDetail(this.$route.params.projectId)
        const party = await this.getPartyService({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId
        })
        projectName = project.name
        partyName = party.tradeName

        const response = await this.getProjectPartyService({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId
        })
        this.partySponsor = response.sponsor

        const pageCentreName = 'page-approval-flow'
        router.push({
          name: pageCentreName,
          params: {
            centreId: this.$route.params.centreId,
            centreCode: this.$route.params.centreCode,
            projectName: projectName,
            partyName: partyName
          }
        })
      }
    },

    async getCentreApprovalAmountOnDatabase () {
      // Get datos de centre_approval_amount
      try {
        console.log('cenntreId on route.params: ', this.$route.params.centreId)
        if (this.$route.params.centreId !== null && this.$route.params.centreId !== undefined) {
          const data = await this.getCentreApprovalAmount({ centreId: this.$route.params.centreId })
          console.log('data on charge: ', data)
          // recorrer data y ponerlo en el formato correcto
          data.forEach(item => {
            if (item.amountTo !== null) {
              item.amountTo = this.$n(item.amountTo, 'max_decimal')
            }
            item.amount = this.$n(item.amount, 'max_decimal')
          })
          this.dataApprovalFlows = data
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Elimina el flujo de aprobación del centro
    async removeCentreApprovalAmount () {
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.delete_approval_amount')
      })

      try {
        await this.deleteCentreApprovalAmount({
          centreId: this.$route.params.centreId,
          projectId: this.$route.params.projectId,
          centreApprovalAmountId: this.currentRowApprovalAmount.id
        })
        // Recargamos datos:
        await this.getCentreApprovalAmountOnDatabase()
        this.$notify({
          title: this.$t('party_detail.notify.delete_approval_amount_data'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('centres.load.text_load_init_data')
    })
    try {
      // Get datos de centre_approval_amount
      await this.getCentreApprovalAmountOnDatabase()
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

  <style lang="scss" scoped>
  .b2b-page-approval-flows {
    padding: 40px 40px 40px 40px;

    ::v-deep .ods-module{
      &__header{
        background-color: var(--color-bg-hover-2);
        padding: 0px;
        .info{
          margin-left: 40px;
          margin-right: 40px;
          height: 72px;
          color: var(--color-bg-interactive);
          size: 16px;
          line-height: 24px;
        }
      }

      &__body{
        padding: 32px;
        .info{
          padding-bottom: 32px;
        }
      }
    }

    .form-actions{
      padding-top: 40px;
      padding-bottom: 40px;
      .ods-button{
        float: right;
      }
    }

    .collapse{
      margin-top: 110px;
      .info {
        margin-left: 1rem;
        color: var(--color-txt-secondary);
      }

      ::v-deep .ods-table{
        th {
          padding: rem(0);
          padding-top: rem(4);

          .cell {
            font-weight: 500;
          }
        }
        &__row{
          .ods-button {
            padding: 0px;
            margin-left: 0px;
            margin-right: 0px;
            i {
              margin-left: 0px;
            }
          }
          .first-button {
            padding: 0px;
            margin-left: 0px;
            margin-right: rem(12);
            i {
              margin-left: 0px;
            }
          }
        }
      }

      .button-collapse {
        float: right;
        margin-top: 1rem;
      }

      ::v-deep .ods-module{
        &__body{
          padding: 0px;
        }
      }
    }  ::v-deep .ods-form-item.hidden label.ods-form-item__label {
      color: transparent !important;
    }
    .button-collapse {
      float: right;
      margin-top: 1rem;
    }
    ::v-deep .ods-form-item.hidden .ods-input.is-disabled .ods-input__inner {
      background-color: transparent !important;
      border-color: transparent !important;
    }
  }
  </style>
